import React, { useEffect, useRef, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { FormikCheckbox, FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { RequestServiceGet } from "../../../../../../../../services/services-mia/RequestServiceGet"
import { Formik, Form } from "formik";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { rowSelected, secondaryModalData, snackbarData, userCredentials } from "recoilState/GlobalState";
import { FormButton } from "components";
import { MIAUsuarioCheck } from "services/services-mia/MiaUsuarioCheck";
import { RequestServiceActions } from "services/services-mia/RequestServiceActions";

const tiposDeFirmas = [
    {
        name: "Digital",
        id: 1,
        value: "D"
    },
    {
        name: "Olografa",
        id: 2,
        value: "O"
    }
]

export default function FormSignerExt({ rolData, roles, updateList, participants = [] }) {
    //Local States 
    const [country, setCountry] = useState([]);
    const [docType, setDocType] = useState([]);
    const [step, setStep] = useState(1);
    const [miaUser, setMiaUser] = useState({});
    const [isUserMia, setIsUserMia] = useState(false)
    const formikRef = useRef();
    //Global States
    const credentials = useRecoilValue(userCredentials);
    const xgridRowSelected = useRecoilValue(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const setSecondaryModalData = useSetRecoilState(secondaryModalData);

    const gender = [
        { value: "M", name: "Masculino" },
        { value: "F", name: "Femenino" },
        { value: "X", name: "No binario" }
    ]

    //Hooks
    useEffect(() => {
        const init = async () => {
            const countryId = await getCountry()
            formikRef?.current?.setFieldValue('country', countryId)
            const documentTypeId = await getDocumentType(countryId);
            formikRef?.current?.setFieldValue('documentType', documentTypeId)
        }
        init()
    }, [])

    //Functions
    const getCountry = async () => {
        const body = {
            service: "MIAPaisGet",
            params: {paisConBandera: "N"}
        }

        const response = await RequestServiceGet(body, credentials);
        const responseToCountry = response.map((country) => {
            return {
                id: country.paisId,
                name: country.paisNombre
            }
        })
        setCountry(responseToCountry);
        return responseToCountry?.[0]?.id;
    }

    const getDocumentType = async (countryId) => {
        const body = {
            service: "TipoDeDocumentoGet",
            params: {
                paisId: countryId
            }
        }
        const response = await RequestServiceGet(body, credentials);
        const responseToDocumentType = response.map((doc) => {
            return {
                id: doc.tipoDeDocumentoId,
                name: doc.tipoDeDocumentoNombre,
                code: doc.tipoDeDocumentoCod
            }
        })
        setDocType(responseToDocumentType);
        return responseToDocumentType?.[0]?.id
    }

    const handleOnChange = async (event) => {
        if (event.target.name === "country") {
            const documentTypeId = await getDocumentType(event.target.value);
            formikRef?.current?.setFieldValue('documentType', documentTypeId)
        }
    }

    const handleSubmit = async (values) => {
        // let valuesTransform = { ...values, documentNumber: values.documentNumber.replace(/[^0-9]/g, '') }
        if (step === 1){
            const response = await MIAUsuarioCheck(values.documentNumber, values.documentType)
            if (response.errmsg === "Usuario inexistente") {
                setIsUserMia(false)
            } else if (response.errmsg === "Usuario existente") {
                const body = {
                    service: "SBMUsuarioMinimoGet",
                    params: {
                        tipoDeDocumentoId: values.documentType,
                        usuarioNroDeDocumentoX: values.documentNumber,
                        usuarioSexo: values.gender,
                        usuarioFechaDeNacimiento: values.fechaNacimiento
                    }
                }
                const response = await RequestServiceGet(body, credentials);

                setMiaUser(response[0]);

                formikRef?.current?.setFieldValue('mail', response[0].usuarioMail);
                formikRef?.current?.setFieldValue('name', response[0].usuarioNombres);
                formikRef?.current?.setFieldValue('surname', response[0].usuarioApellidos);

                setIsUserMia(true);
            }
            setStep(2);
            return;
        }
        if (step === 2){
            if (isUserMia) {
                const body = {
                    service: "SBMDocumentoUsuarioIns",
                    params: {
                        sbmDocumentoId: xgridRowSelected.row.id,
                        usuarioId: miaUser.usuarioId,
                        rolId: roles.find((rol) => rol.sbmRolNombre === rolData)?.sbmRolId,
                        tipoDeDocumentoId: values.documentType,
                        tipoDeDocumentoCod: docType.find((doc) => doc.id === values.documentType)?.code,
                        usuarioNroDeDocumentoX: values.documentNumber,
                        usuarioSexo: values.gender,
                        usuarioFechaDeNacimiento: values.fechaNacimiento,
                        usuarioApellidos: miaUser.usuarioApellidos,
                        usuarioNombres: miaUser.usuarioNombres,
                        usuarioMail: values.mail,
                        sbmDocumentoUsuarioTieneOrden: values.orden ? "Y" : "N",
                        sbmDocumentoUsuarioTag: null,
                        sbmDocumentoUsuarioTipoFirma: values.tipoFirma === "O" ? "O" : "D",
                    }
                }

                const response = await RequestServiceActions(body, credentials, null, setSnackbarInfo)
                if (response.status.code === 1) {
                    setSecondaryModalData({ isOpen: false })
                    await updateList()
                }
                return;
            } 
            const body = {
                service: "SBMDocumentoUsuarioIns",
                params: {
                    sbmDocumentoId: xgridRowSelected.row.id,
                    rolId: roles.find((rol) => rol.sbmRolNombre === rolData)?.sbmRolId,
                    tipoDeDocumentoId: values.documentType,
                    tipoDeDocumentoCod: docType.find((doc) => doc.id === values.documentType)?.code,
                    usuarioNroDeDocumentoX: values.documentNumber,
                    usuarioSexo: values.gender,
                    usuarioFechaDeNacimiento: values.fechaNacimiento,
                    usuarioApellidos: values.surname,
                    usuarioNombres: values.name,
                    usuarioMail: values.mail,
                    sbmDocumentoUsuarioTieneOrden: values.orden ? "Y" : "N",
                    sbmDocumentoUsuarioTag: null,
                    sbmDocumentoUsuarioTipoFirma: values.tipoFirma === "O" ? "O" : "D"
                }
            }

            const response = await RequestServiceActions(body, credentials, null, setSnackbarInfo)
            if (response.status.code === 1) {
                setSecondaryModalData({ isOpen: false })
                await updateList()
            }
        }
    }

    const participantsByRole = participants.filter((e) => e.rol === rolData);
    const hasExistingSigners = participantsByRole.length > 0;
    const signersHaveOrden = participantsByRole.some((p) => p.orden != null && p.orden !== '');

    // Renders 
    const initialForm = () => (
        <Formik
            initialValues={{
                rol: rolData,
                country: 1,
                documentType: 1,
                gender: "M",
                orden: hasExistingSigners ? signersHaveOrden : false,
                tipoFirma: xgridRowSelected.row.sbmDocumentoTipoFirma
            }}
            innerRef={formikRef}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            <Form onChange={handleOnChange}>
                <Grid container columnSpacing={3}>
                    <Grid item lg={6}>
                        <FormikTextInput defaultValue={rolData} name={"rol"} labelText={"Rol"} disabled={true} />
                    </Grid>
                    <Grid item lg={6}>
                        <FormikSelectInput name={"country"} labelText={"Pais"} disabled={isUserMia}>
                            {
                                country.map((country) => (
                                    <option value={country.id}>{country.name}</option>
                                ))
                            }
                        </FormikSelectInput>
                    </Grid>
                    <Grid item lg={6}>
                        <FormikSelectInput name={"documentType"} labelText={"Tipo de documento"} disabled={isUserMia}>
                            {
                                docType.map((doc) => (
                                    <option value={doc.id}>{doc.name}</option>
                                ))
                            }
                        </FormikSelectInput>
                    </Grid>
                    <Grid item lg={6}>
                        <FormikTextInput name={"documentNumber"} placeholder={"12345678"} labelText={"Numero de documento"} disabled={isUserMia} />
                    </Grid>
                    <Grid item lg={6}>
                        <FormikSelectInput name={"gender"} labelText={"Genero"} disabled={isUserMia}>
                            {
                                gender.map((genero) => (
                                    <option value={genero.value}>{genero.name}</option>
                                ))
                            }
                        </FormikSelectInput>
                    </Grid>
                    <Grid item lg={6}>
                        <FormikTextInput name={"fechaNacimiento"} type={"date"} placeholder={"2005-01-01"} labelText={"Fecha de nacimiento"} disabled={isUserMia} />
                    </Grid>
                    {step === 2 && (
                        <>
                            <Grid item lg={6}>
                                <FormikTextInput name={"name"} labelText={"Nombre"} disabled={isUserMia} />
                            </Grid>
                            <Grid item lg={6}>
                                <FormikTextInput name={"surname"} labelText={"Apellido"} disabled={isUserMia} />
                            </Grid>
                            <Grid item lg={6}>
                                <FormikTextInput name={"mail"} placeholder={"example@hotmail.com"} labelText={"Email"} />
                            </Grid>
                            <Grid item lg={6}>
                                <FormikSelectInput name={"tipoFirma"} id={"tipoFirma"} labelText={"Tipo de firma"} disabled={xgridRowSelected.row.sbmDocumentoTipoFirma !== "H"}>
                                    {
                                        tiposDeFirmas.map((tipoFirma) => (
                                            <option value={tipoFirma.value} key={tipoFirma.id}>{tipoFirma.name}</option>
                                        ))
                                    }
                                </FormikSelectInput>
                            </Grid>
                            <Grid item lg={12} display="flex" alignItems="center">
                                <FormikCheckbox labelText={"Firmas en orden de ingreso"} name={"orden"} disabled={hasExistingSigners} />
                            </Grid>
                        </>
                    )}
                </Grid>
                <FormButton
                    newFormData={{ button: isUserMia || step === 2 ? "Invitar" : "Continuar" }}
                    disableAutoClose
                    onCloseModal={() => setSecondaryModalData({ isOpen: false })}
                />
            </Form>
        </Formik>
    );

    return (
        initialForm()
    )

}